import { Link } from 'react-router-dom'
import { format } from 'date-fns'
import '../styles/ProjectCard.css'

function ProjectCard({ project }) {
  const categoryColors = {
    woodworking: '#f59e0b',      // Amber - warm and inviting for wood
    metalworking: '#6366f1',     // Indigo - cool blue for metal
    motorsports: '#ec4899',      // Pink - matches accent color for speed/excitement
    'home-improvement': '#10b981', // Emerald green - fresh and growing
  }

  const categoryColor = categoryColors[project.category] || '#666'

  return (
    <Link to={`/projects/${project.id}`} className="project-card">
      {project.images && project.images.length > 0 && (
        <div className="project-card-image">
          <img src={project.images[0]} alt={project.title} />
        </div>
      )}
      <div className="project-card-content">
        <div
          className="project-category"
          style={{ backgroundColor: categoryColor }}
        >
          {project.category.replace('-', ' ')}
        </div>
        <h3 className="project-title">{project.title}</h3>
        <p className="project-description">{project.description}</p>
        <div className="project-meta">
          <span className="project-date">
            {format(new Date(project.created_at), 'MMM d, yyyy')}
          </span>
        </div>
      </div>
    </Link>
  )
}

export default ProjectCard
